import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonUtilsService } from '../services/commonutils/common-utils.service';

@Pipe({
    name: 'decodeTextField',
    pure: true,
    standalone: false,
})
export class DecodeTextFieldPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: any, returnString?: boolean): any {
        return CommonUtilsService.decodeTextFieldValue(value, this.sanitizer, returnString);
    }
}
